/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Meilen`
};

const en_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Miles`
};

const es_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Millas`
};

const fr_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Miles`
};

const it_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Miglia`
};

const nl_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Miles`
};

const pt_itinerary__options__units__imperial = /** @type {(inputs: {}) => string} */ () => {
	return `Milhas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__units__imperial(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__units__imperial", locale)
	if (locale === "de") return de_itinerary__options__units__imperial(inputs)
	if (locale === "en") return en_itinerary__options__units__imperial(inputs)
	if (locale === "es") return es_itinerary__options__units__imperial(inputs)
	if (locale === "fr") return fr_itinerary__options__units__imperial(inputs)
	if (locale === "it") return it_itinerary__options__units__imperial(inputs)
	if (locale === "nl") return nl_itinerary__options__units__imperial(inputs)
	return pt_itinerary__options__units__imperial(inputs)
};